$(document).ready(function() {
    var ulElement = $("#aa");
    var secondLiElement = ulElement.find("span:eq(0)");
    var secondLiContent = secondLiElement.text();
    var yj_price = Number(secondLiContent.substring(1));   
    
    var okba = $("#flag").text();
    var okbb = Number(okba);
    
    var cj_price = 0 ;
    var save_price = 0 ;
    var saleCode = "";

    // 根据 flag 值计算折扣
    if(okbb==0){
      // flag=0: 特殊产品，无折扣
      cj_price = yj_price.toFixed(2);
      save_price = "0";
      saleCode = "";
    }else if(okbb==1){
      // flag=1: 标签产品（30"=$199 / New Arrival），25% OFF
      cj_price = (yj_price*0.75).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="GLOW25";
    }else if(okbb==2){
      // flag=2: 其他产品，阶梯折扣 GRAD 系列
      if(yj_price>=229){
        cj_price = (yj_price*0.75).toFixed(2);  // 25% OFF
        save_price = (yj_price-cj_price).toFixed(2);
        saleCode ="GRAD25";
      }else if(yj_price>=139){
        cj_price = (yj_price*0.80).toFixed(2);  // 20% OFF
        save_price = (yj_price-cj_price).toFixed(2);
        saleCode ="GRAD20";
      }else if(yj_price>=69){
        cj_price = (yj_price*0.85).toFixed(2);  // 15% OFF
        save_price = (yj_price-cj_price).toFixed(2);
        saleCode ="GRAD15";
      }else{
        cj_price = yj_price.toFixed(2);  // 无折扣
        save_price = "0";
        saleCode ="";
      }
    }else{
      // 默认 25% OFF
      cj_price = (yj_price*0.75).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="GLOW25";
    }


    // 根据 flag 计算分期和价格显示
    if(okbb==0){
      // flag=0: 特殊产品，显示原价分期
      var fq_price = (yj_price/4).toFixed(2);
      $("#aa").removeClass("yc_price");
      $("#bb").removeClass("show_price");
      $("#aa").addClass("show_price");
      $("#bb").addClass("yc_price");
    }else if(okbb==1){
      // flag=1: 标签产品（GLOW25），显示折扣价分期
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");  
    }else if(okbb==2){
      // flag=2: 普通产品（GRAD 系列），显示折扣价分期
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");
    }else{
      // 默认：显示折扣价分期
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");  
    }

    // 设置折扣标识（高亮对应档位）
    if(okbb==1){
      var yhed = "25%";
      var overmn = "For This Order";
      $("#yc2").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");
    }else if(okbb==2){
      // flag=2: 根据折扣金额显示不同档位
      if(yj_price>=229){
        var yhed = "25%";
        var overmn = "For orders over $229";
        $("#yc4").addClass("ycang");
        $("#yc1").removeClass("ycang");
        $("#yc2").removeClass("ycang");
        $("#yc3").removeClass("ycang");
      }else if(yj_price>=139){
        var yhed = "20%";
        var overmn = "For orders over $139";
        $("#yc3").addClass("ycang");
        $("#yc1").removeClass("ycang");
        $("#yc2").removeClass("ycang");
        $("#yc4").removeClass("ycang");
      }else if(yj_price>=69){
        var yhed = "15%";
        var overmn = "For orders over $69";
        $("#yc2").addClass("ycang");
        $("#yc1").removeClass("ycang");
        $("#yc3").removeClass("ycang");
        $("#yc4").removeClass("ycang");
      }else{
        var yhed = "0%";
        var overmn = "";
        $("#yc1").removeClass("ycang");
        $("#yc2").removeClass("ycang");
        $("#yc3").removeClass("ycang");
        $("#yc4").removeClass("ycang");
      }
    }else{
      var yhed = "25%";
      var overmn = "For This Order";
      $("#yc2").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");
    }
  
    $("#savePrice").text("$"+save_price);
    console.log(cj_price);
    $("#bb").text("$"+cj_price);
    $("#windows_bb").text("$"+cj_price);
    $("#win_yj_price").text("$"+yj_price);
    $("#win_savePrice").text("$"+save_price);
    $("#ww").text("$"+cj_price);
    $("#sale_code").text(saleCode);
    $("#win_saleCode").text(saleCode);
    $("#price_fq").text("$"+fq_price);
    $("#yhed").text(yhed);
    $("#overmn").text(overmn);
  });